interface SpinnerProps {
    text?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ text }) => {
  return (
    <div className="d-flex justify-content-center align-items-center">
        <div className="spinner-border text-primary" role="status">
        </div>
        <span className="text-primary fs-5 mx-2">
            {text || 'Loading...'}
        </span>
    </div>
  )
}
